export const CREATE_SURVEY = 'CREATE_SURVEY';
export const UPDATE_SURVEY = 'UPDATE_SURVEY';

export const CREATE_ORGANIZATION = 'CREATE_ORGANIZATION';
export const UPDATE_ORGANIZATION = 'UPDATE_ORGANIZATION';

export const CREATE_SURVEY_SERIES = 'CREATE_SURVEY_SERIES';
export const UPDATE_SURVEY_SERIES = 'UPDATE_SURVEY_SERIES';

export const CREATE_USER = 'CREATE_USER';
export const UPDATE_USER = 'UPDATE_USER';

export const CREATE_EMAIL = 'CREATE_EMAIL';
export const UPDATE_EMAIL = 'UPDATE_EMAIL';

export const CREATE_COUNTRY = 'CREATE_COUNTRY';
export const UPDATE_COUNTRY = 'UPDATE_COUNTRY';

export const CHECKBOX = 'Checkbox';
export const RADIO = 'Radio';
export const FREE_TEXT = 'Free Text';
export const TABLE = 'Table';
export const MATRICE = 'Matrix';

export const MIN_LENGTH_PASSWORD = 8;

export const LOCK = 'LOCK';
export const UNLOCK = 'UNLOCK';

export const horizontalScrollTableStyle = {
  overflowX: 'scroll',
  '&::-webkit-scrollbar': {
    height: '5px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#1976d2',
    borderRadius: '5px',
    cursor: 'pointer',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: '#555',
  },
};

export const verticalScrollStyle = {
  overflowY: 'scroll',
  '&::-webkit-scrollbar': {
    width: '5px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#1976d2',
    borderRadius: '5px',
    cursor: 'pointer',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: '#555',
  },
};

export const DRAFT = 'Draft';
export const CLOSED = 'Closed';
export const PUBLISHED = 'Published';

export const REOPEN = 'Reopen';

export const NOT_OPENED = 'Not opened';
export const OPENED = 'Opened';
export const IN_PROGRESS = 'In progress';
export const SUBMITTED = 'Submitted';

export const MIN_PERCENTAGE_FILLED = 20;

export const FILTER_OPERATIONS = ['Is', 'Is not'];

export const REFRESH_OR_SAVE = 'refreshOrSave';

export const REFRESH = 'refresh';

export const AD_HOC = 'Ad hoc';
export const PUBLISH = 'Publish';

export const SENT = 'Sent';

export const EMAIL_REGEX_STRING = '^[a-z0-9._+\\-]+@[a-z0-9_\\-]+(?:.[a-z]{2,})+$';
export const EMAIL_REGEX = new RegExp(EMAIL_REGEX_STRING);
